<template>
    <div class="long-leave">
        <myBreadCrumb :urls="JSON.stringify(breadcrumbs)" :icon="icon" @createForm="dialog.state=true" ></myBreadCrumb>
        <create-dialog v-model="dialog" @CloseDialog="closeHandler" @fetchData="fetchData"></create-dialog>

        <v-card>
            <v-card-title>
                <span class="d-none d-sm-flex">
                    Danh sách nghỉ dài hạn
                </span>
                <v-spacer></v-spacer>

                <!-- #FILTER MENU -->
                <data-filter2 :filterProps="filters2" :defaults="defaults" @fetchData="fetchData" >
                </data-filter2>
                
            </v-card-title>

            <v-data-table
                :mobile-breakpoint="0"
                :headers="headers"
                :items="items"
                :options.sync="options"
                :server-items-length="totalItem"
                :loading="isLoading"
                loading-text="Đang tải dữ liệu..."
            >
                <template v-slot:[`item.signDate`]="{ item }" >
                    {{ formatDate(item.signDate) }}
                </template>
                
                <template v-slot:[`item.expireDate`]="{ item }" >
                    {{ formatDate(item.expireDate) }}
                </template>
                
                <template v-slot:[`item.isActive`]="{ item }">
                    <v-icon v-if="item.isActive">mdi-check</v-icon>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                    <!-- ********* Edit ****** -->
                    <v-btn @click="editItem(item)" x-small class="mx-1">
                        <v-icon small >
                            mdi-pencil
                        </v-icon> Sửa
                    </v-btn>

                    <!-- ********* Xoa ****** -->
                    <v-btn dark @click="deleteItem(item)" x-small class="mx-1" color="error">
                        <v-icon small>
                            mdi-delete
                        </v-icon>
                        Xóa
                    </v-btn>
                </template>
            </v-data-table>
        </v-card>

        <!-- ************** DELETE CONFIRMATION *************** -->
        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
                <v-card-title class="headline">Bạn có chắc muốn xoá dữ liệu này?</v-card-title>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialogDelete=false">Thoát</v-btn>
                <v-btn color="blue darken-1" text @click="cfmDeleteItem">OK</v-btn>
                <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

import myBreadCrumb from '@/components/BreadCrumb';
import http from '@/components/services/http-common';
import DataFilter2 from '@/components/DataFilter2.vue';
import Create from './Create';

export default {
    name: 'LongLeave',
    components: {
        myBreadCrumb,
        'data-filter2': DataFilter2,
        "create-dialog": Create,
    },
    watch: {
        options: {
            handler (val) {
                this.fetchData();
            },
            deep: true,
        },
    },
    props: ["breadcrumbs", "icon"],
    data() {
        return {
            ROOT_URL: "LongLeaves",

            //TABLE DATA
            filterState:[],
            
            filters2: {
                checkboxes: [
                    {text: "Hiện tại", value: "isCurrent"},
                ],
                searchOns: [{name: "Nhân viên", code:"employeeA"}, {name: "Người ký", code:"employeeB"}],
                dateOns: [{name: "Ngày ký", code:"signDate"}, {name: "Ngày kết thúc", code:"expireDate"}],
            },
            defaults: {
                dateOn: "expireDate",
                searchOn: "employeeA",
                filters: {
                    isCurrent: true,
                },
            },

            headers: [
                {text:"", value: "actions"},
                {text: "Mã", value: "code"},
                {text: "Tên loại nghỉ", value: "name"},
                {text: "Hoạt động", value: "isActive"},
                {text: "Có lương", value: "hasSalary"},
                {text: "Ghi chú", value: "Note"},
            ],
            items: [],
            options: {},
            totalItem: 0,
            isLoading: true,

            //DIALOG
            dialog: {
                state: false,
                item: undefined,
            },
            dialogDelete: false,
            targetItem: {},

        }
    },
    methods: {
        //DATA JS
        fetchData (e) {
            this.filterState = e;
            let params =  { ...e, 
                                sortBy: this.options.sortBy, //array
                                sortDesc: this.options.sortDesc, //array
                                page: this.options.page,
                                };
            return http.get(this.ROOT_URL, {
                params: params
            })
            .then(res => {
                this.items = res.data.items;
                this.totalItem = res.data.totalItem;
                this.isLoading = false;
            }).catch(err => {})
        },

        //DIALOG METHOD
        openDialog() {
                this.params = {
            }
        },
        closeHandler () {
            this.dialog = {state: false, item: undefined}
        },
        editItem (item) {
            this.dialog = {state: true, item: item}
        },
        deleteItem (item) {
            this.dialogDelete = true;
            this.targetItem = item;
        },
        cfmDeleteItem() {
            http.delete(this.ROOT_URL + "/" +this.targetItem.code).then(res => {
                this.fetchData();
                this.dialogDelete = false;
            }).catch(err => {
                switch (err.response.status)
                {
                    case 403:{
                        this.unauthorizeAlert();
                        this.dialogDelete = false;
                        break;
                    }
                    default:
                        break;
                }
            })
        },
    }
}
</script>